import { getVisibleChemistryPackages } from "../../../../../services/utilities/a15Workarea";

const TITLE = "Laboratory Task Printout";
const FEATURES = "top=100px,left=100px,width=794px,height=1123px";

/**
 * Packages of the task as an array of service ids,
 * same as the task rows (table/patient.jsx, collapse/record.jsx).
 */
export const taskPackages = (task = {}) => {
  const { packages, form } = task;
  if (form === "Chemistry") return getVisibleChemistryPackages(task);
  if (packages && typeof packages === "object")
    return Array.isArray(packages)
      ? packages
      : Object.keys(packages).map((k) => Number(k));
  return packages ? [packages] : [];
};

/**
 * Opens the print window right away so it is not blocked by the browser
 * when the result is printed after a request, the result is loaded later
 * using printLabTask.
 */
export const openPrintWindow = () => window.open("", TITLE, FEATURES);

/**
 * Prints the laboratory result of the task.
 * @param {object} task - task with populated signatories, patient and branchId
 * @param {Array} preferences - preferences collections (services with references)
 * @param {Window} printWindow - window opened by openPrintWindow
 */
export const printLabTask = (task = {}, preferences = [], printWindow) => {
  const services = preferences.filter(({ id }) =>
    (task.services || []).includes(id)
  );
  localStorage.setItem("taskPrintout", JSON.stringify({ ...task, services }));

  const { packages } = task;
  const url = `${window.location.origin}/printout/laboratory/${
    Array.isArray(packages) && packages.includes(176) ? "drugtest" : "task"
  }`;

  const target = printWindow && !printWindow.closed
    ? printWindow
    : window.open("", TITLE, FEATURES);

  if (!target) return console.warn("Popup blocked or failed to open.");
  target.location.href = url;
  target.focus();
};
